module.exports = __webpack_public_path__ + "static/media/marathon newspaper 3.24a3ae58.jpg";